import { firebaseApp } from 'boot/firebase';
import { boot } from 'quasar/wrappers';
import { firestoreDefaultConverter, VueFire, VueFireFirestoreOptionsAPI } from 'vuefire';

/*
  snapshot.data() DOES NOT contain the `id` of the document. By default, Vuefire adds
   it as a non-enumerable property named id. This allows to easily create copies when
   updating documents, as using the spread operator won't copy it
*/
const serialize = (snapshot) => {
  // A document that has been deleted still reaches the converter, and snapshot.data() is undefined
  // for it — Object.defineProperties would throw "Cannot convert undefined or null to object".
  if (!snapshot.exists()) {
    return null;
  }

  return Object.defineProperties(snapshot.data(), {
    id: { value: snapshot.id },
    hasLocalOrigin: { value: snapshot.metadata.hasPendingWrites },
  });
};

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(({ app }) => {
  app.use(VueFire, {
    firebaseApp,
    modules: [
      VueFireFirestoreOptionsAPI(),
    ],
    converter: {
      toFirestore(data) {
        return firestoreDefaultConverter.toFirestore(data);
      },
      fromFirestore(snapshot) {
        return serialize(snapshot);
      },
    },
  });
});
